import styled, { css } from "styled-components"
import { Link } from "react-router-dom"
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import PhoneIcon from '@material-ui/icons/Phone'
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import logoMobile from '../../assets/images/sprites_27_9.png'
import mobileIcon from '../../assets/images/sprite_icon16v14.png'
import ic32v12 from '../../assets/images/sprite_icon32v12.png'
import SearchIcon from '@material-ui/icons/Search';

export const HeaderWrap = styled.header`
    position: relative;
    z-index: 2;
`

export const HeaderTop = styled.div`
    background: #fff;
`

export const HeaderTopLeft = styled.div``

export const LogoLink = styled(Link)`
    text-decoration: none;
`
export const Logo = styled.img``

export const HeaderTopRight = styled.div`
    margin-left: auto;
`
export const HeaderFlex = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 768px) {
        padding: 3px 0;
    }
`
export const LogoList = styled.ul`
    display: flex;
    list-style: none;
`

export const LogoItem = styled.li``

export const HeaderTopMenu = styled.ul`
    display: flex;
    list-style: none;
`;

export const UserMenu = styled.ul`
    list-style: none;
    position: absolute;
    right: 0;
    top: 100%;
    width: 194px;
    background: #fff;
    transform: rotateX(90deg);
    transition: all .2s ease-in;
    transform-origin: 0 0;
    z-index: 10;
`
export const UserMenuLink = styled(Link)`
    text-decoration: none;
    width: 178px;
    padding: 6px 0;
    padding-left: 16px;
    line-height: 28px;
    font-size: 15px;
    border-bottom: 1px solid #d6d6d6;
    color: #222;
    display: block;
    width: 100%;
`

export const UserMenuItem = styled.li`
    &:hover a{
        background-color: #e32;
    }
`

export const HeaderTopItem = styled.li`
    margin-left: 24px;
    display: flex;
    align-items: center;
    position: relative;

    &:hover ul{
        transform: rotateX(0deg);
    }
`

export const HeaderTopLink = styled(Link)`
    text-decoration: none;
    line-height: 28px;
    color: #222;
    font-size: 12px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
`;

const iconStyle = css`
    font-size: 16px !important;
    margin-right: 1px;
    position: relative;
    bottom: 2px;
`;

export const HotlineIcon = styled(PhoneIcon)`
    ${iconStyle}
`;

export const UserIcon = styled(PersonOutlineIcon)`
    ${iconStyle}
`;

export const Separate = styled.span`
    margin: 0 2px;
    position: relative;
    bottom: 1px;

    @media screen and (max-width: 767px) {
        margin: 0 4px;
    }
`;

export const ProfileLink = styled(Link)`
    display: flex;
    text-decoration: none;
    align-items: center;
`

export const Avatar = styled.img`
    width: 14px;
    height: 14px;
    margin-right: 6px;
`

export const Username = styled.span`
    color: #222;
    line-height: 28px;
    font-size: 12px;
    font-weight: 500;
    max-width: 140px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`

export const HeaderMiddle = styled.div`
    background-image: linear-gradient(to left,#9f041b,#e32);
    padding: 7px 0;
    position: relative;

    @media screen and (max-width: 767px) {
        background: #fff;
        border-bottom: 1px solid #d8d8d8;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1;
    }
`

export const MainLogo = styled(Link)`
    width: 99px;
    height: 29px;
    background-position: -6px -68px;
    display: block;
    background-repeat: no-repeat;
    background-size: 400px 300px;

    @media screen and (max-width: 767px) {
        background-image: url(${logoMobile}) !important;
        background-size: 209px 189px;
        background-position: 0 -2px;
        width: 91px;
        height: 30px;
    }
`

export const HeaderMiddleMenu = styled.ul`
    display: flex;
    list-style: none;
    margin-left: auto;
`

export const HeaderMiddleItem  = styled.li``

export const HeaderMiddleLink  = styled(Link)`
    text-decoration: none;
    color: #fff;
    text-transform: uppercase;
    padding: 10px;
    font-size: 11px;
    font-weight: 500;
    display: block;

    &.switch {
        color: #222;
        background: #fff;
        padding: 4px 8px;
        border-radius: 2px;
        margin-left: 24px;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 11px;
        text-transform: none;
        position: relative;
        top: 5px;

        &:hover {
            background: #e8e8e8;
        }
    }
`

export const BellIcon = styled.img`
    margin-right: 4px;
`

export const HeaderBottom = styled.div`
    display: ${({hide}) => hide ? 'none':'block'};

    @media screen and (max-width: 767px) {
        padding-top: 51px;
    }
`



export const HeaderBottomMenu = styled.ul`
    display: flex;
    list-style: none;
    width: 100%;
    border-bottom: 2px solid #e32;
    padding-bottom: 5px;
    background: #fff;
    margin-top: ${({menuMt}) => menuMt ? '20px':''};
`
export const HeaderBottomMenuItem = styled.li`
    margin-right: 7px;
    position: relative;

    &:first-child a {
        background-repeat: no-repeat !important;
        background-size: 16px auto!important;
        width: 12px;
        height: 10px;
        background-position: -1px -865px!important;
    }
`

export const HeaderBottomMenuLink = styled(Link)`
    text-transform: uppercase;
    font-size: 11px;
    color: #222;
    display: block;
    text-decoration: none;
    font-weight: 700;
`

export const CallButton = styled.a`
    display: flex;
    text-decoration: none;
    margin-left: 30px;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
`

export const PhoneIc = styled(PhoneInTalkIcon)`
    color: #fff;
`

export const Bar = styled.span`
    width: 20px;
    height: 3px;
    margin-top: 3.6px;
    display: block;
    background: #fff;
    transition: transform .3s;
    transform-origin: center center;

    @media screen and (max-width: 767px) {
        background: #888;
    }
`

export const Bars = styled.div`
    cursor: pointer;

    &.active ${Bar}{
        &:nth-child(1) {
            transform: translateY(6px) rotate(-45deg);
        }

        &:nth-child(3) {
            transform: translateY(-6px) rotate(45deg);
            margin-top: 9px;
        }

        &:nth-child(2) {
            display: none;
        }
    }

`

export const TabletMenu = styled.ul`
    position: absolute;
    top: 100%;
    width: 100%;
    list-style: none;
    background: #fff;
    z-index: 2;
    right: 100%;
    transition: all .3s ease-in;
    visibility: hidden;
    box-shadow: 0 3px 16px rgb(0 0 0 / 25%);

    &.show {
        right: 0;
        visibility: visible;
    }

    @media screen and (max-width: 767px) {
        height: 100vh;
        padding-bottom: 56px;
        overflow: auto;
    }
`

export const TabletCategory = styled.li`
    display: flex;
    align-items: center;
    
    border-bottom: 1px solid #e7ebf1;

    &:first-child {
        background: #f4f4f4;
    }
    &.mobile-auth {
        display: none;
        @media screen and (max-width: 767px) {
            display: flex;
        }
    }

`

export const MobileCateLink = styled(Link)`
    color: #303030;
    font-size: 16px;
    font-weight: bold;
    text-decoration: none;
    display: flex;
    align-items: center;
`

export const CategoryLink = styled(Link)`
    color: #222;
    font-weight: bold;
    font-size: 16px;
    display: block;
    text-decoration: none;
    width: 100%;
    padding: 16px;

    @media screen and (max-width: 767px) {
        padding: 8px 12px;
        
    }
`

export const MobileButtons = styled.ul`
    display: flex;
    align-items: center;
    margin-left: auto;
    list-style: none;
`

export const MobileButton = styled.li`
    border-radius: 50%;
    border: 1px solid #6c6c6c;
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    &:last-child {
        border: none;
    }

    &:nth-child(3) {
        border: none;
        margin-bottom: 4px;
    }
`

const mobileButton = css`
    display: block;
    text-decoration: none;
    background: url(${mobileIcon});
`

export const YoutubeButton = styled.a`
    ${mobileButton};
    background-size: 16px auto;
    width: 16px;
    height: 16px;
    background-position: 0px -128px;
`

export const FacebookButton = styled.a`
    background: url(${ic32v12});
    background-position: -8px -1079px;
    width: 16px;
    height: 19px;
    transform: scale(.8);
    background-size: 32px auto;
`

export const PhoneButton = styled.a`
    ${mobileButton};
    background-position: 0 -653px;
    width: 16px;
    height: 19px;
    background-size: 16px auto;
`

export const SearchButton = styled(Link)`
    ${mobileButton};
    background-position: 0 -672px;
    width: 16px;
    height: 19px;
    background-size: 16px auto;
`

export const MobileSearchInput = styled.input`
    width: 100%;
    outline: none;
    border: 1px solid #ddd;
    padding: 0 50px 0 12px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    height: 100%;
`

export const MbSearchForm = styled.form`
    left: 0;
    transition: all .3s ease;
    z-index: 10000;
    width: 100%;
    position: fixed;
    height: 51px;
    top: 0;
    transform: ${({show}) => show ? 'translateY(0)':'translateY(-100%)'};
`

export const MbSeachSubmit = styled.button`
    border: none;
    outline: none;
    background: none;
    position: absolute;
    width: 50px;
    height: 100%;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const SearchIc = styled(SearchIcon)`
    font-size: 16px;
    color: #333;
    opacity: 0.8;
`

export const MobileOverlay = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.35);
    z-indeX: 9999;
    opacity: ${({show}) => show ? '1':'0'};
    visibility: ${({show}) => show ? 'visible':'hidden'};;
    transition: all .3s ease;
`

export const MenuOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    opacity: 0;
    visibility: hidden;
    transition: all .3s ease;
    z-index: 1;

    &.show {
        opacity: 1;
        visibility: visible;
    }
`

export const PersonIc = styled(PersonOutlineIcon)`
    font-size: 18px;
    margin-bottom: 1px;;
`

export const HelloUser = styled.p`
    font-size: 15px;
    font-weight: bold;
    color: #222;
    display: flex;
    align-items: center;
    padding: 16px;

    @media screen and (max-width: 767px) {
        padding: 8px 12px;
        
    }
`

export const UserMobileMenu = styled.ul`
    list-style: none;
    width: 100%;
    background: #dedddd;
    padding: 0 16px 0 20px;
`

export const UserMobileItem = styled.li``

export const UserMobileLink = styled(Link)`
    color: #222;
    text-decoration: none;
    padding: 8px 12px;
    display: block;
    font-weight: 500;
`